import { itemProps } from "../modules/ProjectList/Item";

import TeachingMe from "../assets/images/TeachingMe.png";
import Shop from "../assets/images/Shop.png";
import ShootType from "../assets/images/shootType.png";
import ip15 from "../assets/images/iphone15_landingpage.png";
export const listProject: itemProps[] = [
  {
    nameProject: `Iphone 15 Pro Apple`,
    toolProject: `3D Landing Page - Three.js`,
    desProject: `An interactive iPhone 15 landing page inspired by Apple's product showcase. The project features smooth 3D model rendering, scroll-based animations, and modern UI effects built with React, Three.js, and GSAP.`,
    listDes: [
      `Built with React, TypeScript, and Vite`,
      `3D product rendering using Three.js and React Three Fiber`,
      `Scroll-based animations and transitions using GSAP`,
      `Responsive UI styled with TailwindCSS`,
      `Optimized rendering with Drei helpers and modern React architecture`,
    ],
    linkProject: "https://iphone15-apple-landingpage.vercel.app/",
    imgLogo: ip15,
    number: 4,
  },

  {
    nameProject: `ShootType`,
    toolProject: `Minigame - Typing Shooting`,
    desProject: `A fast-paced typing game where players shoot enemies by typing words correctly. Built with Phaser and TypeScript, the game focuses on improving typing speed while delivering an arcade-style shooting experience.`,
    listDes: [
      `Developed using Phaser and TypeScript with a modular game architecture`,
      `Enemies are defeated by typing the words displayed below them`,
      `Designed with lightweight assets and optimized for smooth browser gameplay`,
    ],
    linkProject: "https://shoot-type.vercel.app/",
    imgLogo: ShootType,
    number: 3,
  },
  {
    nameProject: `Teaching Me`,
    toolProject: `Knowledge sharing forum - School Project`,
    desProject: `This is forum website. You can register/login into system, find user and post by name, create/edit a post, interact with another user by vote, comment in their post. This project using ReactJS & Typescript, React Router V6, TailwindCss, RestFul Api, ReduxToolkit, JWT,... `,
    listDes: [``, ``, ``],
    linkRepo: "https://github.com/dnt201/TLCN",
    imgLogo: TeachingMe,
    number: 2,
  },
  {
    nameProject: `ND Shop`,
    toolProject: `E-commerce web site - School Project`,
    desProject: `A web app is ecommerce-site. Use MERN stack (MongoDB - Express Express - ReactJS - NodeJS). Some feature belike login/register, buy product with cart (filter by range of money, by brand),...`,
    listDes: [``, ``, ``],
    linkRepo: "https://github.com/dnt201/DoAnCNTT",
    imgLogo: Shop,
    number: 1,
  },
];
